<template>
  <div>
    <b-card>
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div
          v-for="notification_item in Notifications"
          :key="notification_item.id"
        >
          <b-row>
            <b-col> {{ notification_item.noti_type.title }} </b-col>
            <b-col>
              <div class="content-ch" style="display:none">
                <b-form-checkbox
                  :id="'telegram_' + notification_item.id"
                  v-model="notification_item.telegram"
                  value="1"
                >
                  تلکرام
                </b-form-checkbox>
              </div>
              <div class="content-ch">
                <b-form-checkbox
                  :id="'sms_' + notification_item.id"
                  v-model="notification_item.sms"
                  value="1"
                >
                  پیامک
                </b-form-checkbox>
              </div>
             <div class="content-ch">
                <b-form-checkbox
                  :id="'email_' + notification_item.id"
                  v-model="notification_item.email"
                  value="1"
                >
                  ایمیل
                </b-form-checkbox>
              </div>
            </b-col>

            <b-col>
               <div class="content-ch">
                <b-form-checkbox
                  :id="'panel_' + notification_item.id"
                  v-model="notification_item.panel"
                  value="1"
                >
                  اعلان درون پنل
                </b-form-checkbox>
              </div>
              
            </b-col>
          </b-row>
          <hr />
        </div>

        <br />
        <b-button type="submit" class="mr-3" variant="success">ثبت</b-button>
        <b-button class="mr-3" variant="danger" href="/dashboard"
          >بازگشت</b-button
        >
      </b-form>
    </b-card>
  </div>
</template>
<style>
.content-ch {
  margin-top: 10px;
}
</style>
<script>
import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "userChangeNotification",
  data: function () {
    return {
      Notifications: null,
      errors: [],
    };
  },
  components: {},
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تنطیم اعلانات" }]);
    this.filterData();
  },
  methods: {
    onSubmit() {
      var data = { notifications_item:this.Notifications};
      httpHelper.postData("notification", data).then((response) => {
        if (response.success) {
          this.$router.push("/dashboard");
        } else {
          this.errors = [];
           for (var key in response.error) {
              response.error[key].forEach(element => {
                this.errors.push(element);
              });
            }
          
        }
      });
    },
    filterData: function () {
      httpHelper.setAuth();

      httpHelper.getData("notification").then((res) => {
        this.Notifications = res.result;
      });
    },
  },
};
</script>
